import {
  SET_ADV_SEARCH_FORM_TYPE,
  FETCH_MASTER_CARDS,
  FETCH_MASTER_CARDS_SUCCESS,
  FETCH_MASTER_CARDS_FAILURE,
  ONGOING_ADVANCE_SEARCH,
  ADD_MASTER_DATA,
  ADD_MASTER_DATA_FAILURE,
  ADD_MASTER_DATA_SUCCESS,
  UPDATE_MASTER_DATA,
  UPDATE_MASTER_DATA_FAILURE,
  UPDATE_MASTER_DATA_SUCCESS,
  FETCH_MASTER_DATA,
  FETCH_MASTER_DATA_FAILURE,
  FETCH_MASTER_DATA_SUCCESS,
  RESET_ADDED_DATA,
  DELETE_MASTER_DATA,
  DELETE_MASTER_DATA_FAILURE,
  DELETE_MASTER_DATA_SUCCESS,
  SET_MASTER_ERROR,
} from './MastersAction';

const defaultState = {
  activeIndices: [],
  advSearchFormType: '',
  isAdvSearchOngoing: false,
  cardsData: [],
  isCardDataLoading: false,
  isCardDataError: false,
  masterData: [],
  showAddedData: false,
  addedData: {},
  isLoading: false,
  isError: false,
  errorMessage: '',
  validateMasterData: false,
};

const MastersReducer = (state = defaultState, action = {}) => {
  const prevValidateMasterData = state.validateMasterData;
  switch (action.type) {
    case SET_ADV_SEARCH_FORM_TYPE:
      return { ...state, advSearchFormType: action.payload };
    case ONGOING_ADVANCE_SEARCH:
      return { ...state, isAdvSearchOngoing: action.payload };
    case FETCH_MASTER_CARDS:
      return { ...state, isCardDataLoading: true, isCardDataError: false };
    case FETCH_MASTER_CARDS_SUCCESS:
      return {
        ...state,
        cardsData: action.payload,
        isCardDataLoading: false,
      };
    case FETCH_MASTER_CARDS_FAILURE:
      return {
        ...state,
        cardsData: [],
        isCardDataLoading: false,
        isCardDataError: true,
      };

    case FETCH_MASTER_DATA:
      return {
        ...state,
        masterData: [],
        isLoading: true,
        paginationData: {},
        isError: false,
        activeIndices: [],
      };
    case FETCH_MASTER_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        masterData: action.payload,
        paginationData: action.paginationData,
        isError: false,
        activeIndices: [0],
      };
    case FETCH_MASTER_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        masterData: [],
        paginationData: {},
        isError: true,
        activeIndices: [],
      };

    case RESET_ADDED_DATA:
      return {
        ...state,
        addedData: {},
        showAddedData: false,
        isError: false,
      };
    case ADD_MASTER_DATA:
      return {
        ...state,
        isLoading: true,
        showAddedData: false,
        isError: false,
      };
    case ADD_MASTER_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        addedData: action.payload,
        showAddedData: true,
        isError: false,
      };
    case ADD_MASTER_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        showAddedData: false,
        addedData: {},
        isError: true,
      };
    case UPDATE_MASTER_DATA:
      return { ...state, isLoading: true, isError: false };
    case UPDATE_MASTER_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        validateMasterData: !prevValidateMasterData,
        isError: false,
      };
    case UPDATE_MASTER_DATA_FAILURE:
      return { ...state, isLoading: false, isError: true };

    case DELETE_MASTER_DATA:
      return { ...state, isLoading: true, isError: false };
    case DELETE_MASTER_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        validateMasterData: !prevValidateMasterData,
        errorMessage: '',
        isError: false,
      };
    case DELETE_MASTER_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload,
        isError: true,
      };

    case SET_MASTER_ERROR:
      return { ...state, isError: action.payload };

    default:
      return state;
  }
};
export default MastersReducer;
